import { useEffect, useRef, useState } from 'react';

const features = [
  {
    icon: 'ri-building-line',
    title: 'Commercial Focus',
    description: 'Specialized in serving property managers, HOAs, retail centers, and municipalities.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Quality Materials',
    description: 'We use only premium-grade sealants, paints, and materials for lasting results.'
  },
  {
    icon: 'ri-time-line',
    title: 'Fast Turnaround',
    description: 'Efficient scheduling and execution to minimize disruption to your business operations.'
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Competitive Pricing',
    description: 'Fair, transparent pricing with detailed quotes and no hidden fees or surprises.'
  }
];

export default function WhyChoose() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="py-16 lg:py-24 bg-stone-50">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-8">
        <div className={`text-center mb-12 lg:mb-16 ${isVisible ? 'lg:animate-fade-up' : 'lg:opacity-0'}`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-[1.05]" style={{ fontFamily: 'Oswald, sans-serif' }}>
            Why Sooner Blacktop
          </h2>
          <p className="text-xl text-gray-600 max-w-[720px] mx-auto leading-[1.45]">
            Dependable pavement maintenance backed by professional service and quality workmanship
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-6 lg:p-7 border border-gray-200 hover:border-yellow-400 transition-all duration-300 lg:card-hover ${
                isVisible ? 'lg:animate-fade-up' : 'lg:opacity-0'
              }`}
              style={{ animationDelay: `${80 * index}ms` }}
            >
              <div className="w-14 h-14 bg-yellow-400 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-black`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-[1.45]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
